import { NVButton } from '@nv/basic-components'
import EditIcon from '@nv/images/design/edit-icon'
import { useTranslation } from 'react-i18next'
import Skeleton from '../skeleton/Skeleton'
import styles from './CandidateBio.module.scss'

export const CandidateBio = ({ editEnabled = false, onClick, bio, loading }: any) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  if (editEnabled) {
    return (
      <div className={styles['container']}>
        <div className={styles['header']}>
          <h2>{t('main.about')}</h2>
          {editEnabled && (
            <NVButton variant='text' onClick={onClick} text={bio ? t('buttons.edit') : t('buttons.addBio')} icon={<EditIcon />} />
          )}
        </div>
        <div className={styles['content']}>
          <div className={styles['about']}>
            <strong>{t('main.englishCol')}</strong>
            <p>{loading ? <Skeleton width={200} height={20} /> : bio.en}</p>
          </div>
          <div className={styles['about']}>
            <strong>{t('main.frenchCol')}</strong>
            <p>{loading ? <Skeleton width={200} height={20} /> : bio.fr}</p>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <h2>{t('main.about')}</h2>
      </div>
      <div className={styles['content']}>
        <div className={styles['about']}>
          <p>{loading ? <Skeleton width={200} height={20} /> : bio?.[currentLanguage] ? bio[currentLanguage] : ''}</p>
        </div>
      </div>
    </div>
  )
}
